import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import actions from './actions';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error, info) {
    if (!this.state.hasError) {
      this.setState(ErrorBoundary.getDerivedStateFromError(error));
    }

    if (process.env.NODE_ENV === 'production') {
      const {name,message,lineNumber,columnNumber,filename,stack} = error;
      this.props.actions.logError({
        error: JSON.stringify({name,message,lineNumber,columnNumber,filename,stack}),
        info: info.componentStack
      });
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div>Algo de errado aconteceu.<br />A falha já foi registrada para análise posterior.</div>;
    }

    return this.props.children; 
  }
}

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(ErrorBoundary);


// WEBPACK FOOTER //
// ./src/ErrorBoundary.js